import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { generateInvoice } from '@/api/orders-dispatches';
import { clearItemWiseCache, downloadCSV, getAllData, getItemWiseReports } from '@/api/orders-products-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import { getAdmins } from '@/api/admins';
import { searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import Enabled from '@/components/Enabled/index.vue';
import { searchProducts } from '@/api/products';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isBranchManager, isSuperAdmin, isZonalManager } from '@/common';
import { BRANCH_MANAGER, ZONAL_MANAGER } from '@/constants/roles.constants';
import { getRanges } from '@/api/ranges';
import { getCategories } from '@/api/categories';
import moment from 'moment';
import * as XLSX from 'xlsx';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.dateRange = {
      start: '',
      end: ''
    };
    this.dialogVisible = false;
    this.isAgent = false;
    this.dispatchId = 0;
    this.unitManagers = [];
    this.unitList = [];
    this.dealerList = [];
    this.agentList = [];
    this.stateList = [];
    this.cityList = [];
    this.products = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.salesExecutiveAdmins = [];
    this.zonalManagerAdmins = [];
    this.selectedVariationId = null;
    this.dealerListLoading = false;
    this.stateListLoading = false;
    this.cityListLoading = false;
    this.productListLoading = false;
    this.selectedProduct = null;
    this.grandTotalCartons = '';
    this.totalCartonArray = [];
    this.categoryId = null;
    this.subCategoryId = null;
    this.rangeList = [];
    this.categoryList = [];
    this.subCategoryList = [];
    this.assignedBranches = [] || null;
    this.showFilters = false;
    this.hasSearched = false;
    this.statusOptions = ['Pending', 'Request Approval', 'Approved', 'Rejected'];
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.statusColorMap = {
      Pending: 'warning',
      'Request Approval': 'primary',
      Approved: 'success',
      Rejected: 'danger'
    };
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      selectedVariationId: undefined,
      adminId: undefined,
      agentId: undefined,
      productId: undefined,
      categoryId: undefined,
      subCategoryId: undefined,
      productVariationId: undefined,
      cityName: undefined,
      stateId: undefined,
      status: 'Approved',
      startDate: undefined,
      endDate: undefined,
      sort: 'createdTimestamp,ASC',
      applyBranchIdFilter: true,
      branchId: undefined
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.loggedInAdmin = null;
    // getSummaries(param: any) {
    //   const { columns, data } = param;
    //   const sums: any = [];
    //   columns.forEach((column: any, index: any) => {
    //     if (index === 15) {
    //       let totalCartons: any = [];
    //       this.totalCartonArray.forEach((item) => {
    //         totalCartons.push(item.totalCarton);
    //       });
    //       const values = totalCartons;
    //       // loop over & null check
    //       if (!values.every((value: any) => isNaN(value))) {
    //         // sum them using reduce
    //         sums[index] = values.reduce((prev: any, curr: any) => {
    //           // value conversion (do check with Sandesh if toFixed something else required for decimal precision)
    //           const value = Number(curr);
    //           // null check
    //           if (!isNaN(value)) {
    //             return prev + curr;
    //           } else {
    //             return prev;
    //           }
    //         }, 0); // initial value
    //       } // loop if ends
    //     }
    //     if (index === 15) {
    //       sums[15] = `${sums[15].toFixed(2)}/${this.grandTotalCartons.toFixed(
    //         2
    //       )}`;
    //     }
    //   });
    //   return [, , , , , , , , , , , , , , , sums];
    // }
  }
  async activated() {
    try {
      this.loggedInAdmin = AdminModule;
      // check if logged in user is Agent/Admin
      if (this.loggedInAdmin.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = this.loggedInAdmin.agentId;
      }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch agents for the assigned branchId
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      // Default to the current financial year so the report loads data on
      // first visit instead of silently making no API call (getList() skips
      // fetching entirely when startDate/endDate are unset).
      if (!this.dateRange.start || !this.dateRange.end) {
        const currentMonth = moment().month();
        const currentYear = moment().year();
        const isFinancialYearStart = currentMonth >= 3; // April starts the financial year
        const startYear = isFinancialYearStart ? currentYear : currentYear - 1;
        const endYear = startYear + 1;
        this.dateRange = {
          start: moment(`${startYear}-04-01`).format('YYYY-MM-01 12:00') + ' am',
          end: moment(`${endYear}-03-31`).endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
        };
      }
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      // get dispatch list
      await this.getStateList();
      await this.fetchRanges();
      await this.fetchSalesExecutiveManagers();
      await this.fetchZonalAdminManagers();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async fetchSubCategories() {
    if (this.categoryId) {
      this.subCategoryList = await getCategories(getQuery({
        enabled: true,
        parentId: this.categoryId,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$in',
          rangeId: '$in'
        }
      }));
      if (this.subCategoryList.length === 0) {
        this.subCategoryId = undefined;
      }
    } else {
      this.subCategoryList = [];
    }
  }
  async fetchCategories() {
    if (this.listQuery.rangeId) {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$isnull',
          rangeId: '$in'
        }
      }));
      if (this.categoryList.length === 0) {
        this.categoryId = undefined;
      }
    } else {
      this.categoryList = [];
    }
  }
  handleSubCategoryFilter() {
    this.subCategoryId = undefined;
    if (this.categoryId) {
      this.fetchSubCategories();
    } else {
      this.categoryId = undefined;
    }
  }
  handleCategoryFilter() {
    this.categoryId = undefined;
    this.subCategoryId = undefined;
    this.fetchCategories();
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  isSalesExecutiveAdmin() {
    return isBranchManager();
  }
  isZonalManagerAdmin() {
    return isZonalManager();
  }
  async fetchSalesExecutiveManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [BRANCH_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.salesExecutiveAdmins = allManagers.data;
  }
  async fetchZonalAdminManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [ZONAL_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.zonalManagerAdmins = allManagers.data;
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange && this.dateRange.start && this.dateRange.end) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      }
      if (!this.listQuery.startDate || !this.listQuery.endDate) {
        this.list = [];
        this.total = 0;
        this.listLoading = false;
        return;
      }
      this.listQuery.categoryId = undefined;
      this.listQuery.subCategoryId = undefined;
      if (this.categoryId) {
        this.listQuery.categoryId = Array.isArray(this.categoryId) ? +this.categoryId[0] : +this.categoryId;
      }
      if (this.subCategoryId) {
        this.listQuery.subCategoryId = Array.isArray(this.subCategoryId) ? +this.subCategoryId[0] : +this.subCategoryId;
      }
      this.listQuery.applyBranchIdFilter = true;
      const data = await getItemWiseReports(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getListWithoutPagination() {
    const queryWithoutPagination = {
      ...this.listQuery
    };
    delete queryWithoutPagination.page;
    delete queryWithoutPagination.limit;
    const data = await getAllData(getQuery(queryWithoutPagination));
    return data;
  }
  formatDiscount(value) {
    return value === null ? 0 : value;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList(query = null) {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = null) {
    try {
      if (stateId.length > 0) {
        this.cityListLoading = true;
        this.cityList = await getCities(getQuery({
          enabled: true,
          stateId,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq',
            stateId: '$in'
          }
        }));
        this.cityListLoading = false;
      }
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        this.products = await searchProducts(getQuery({
          keyword: query,
          searchByCatalogueCode: false
        }));
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  handleProductSelection(value) {
    if (value) {
      if (Array.isArray(value)) {
        const productIds = [];
        const productVariationIds = [];
        value.forEach(item => {
          if (item.startsWith('product-')) {
            productIds.push(+item.replace('product-', ''));
          } else if (item.startsWith('variation-')) {
            productVariationIds.push(+item.replace('variation-', ''));
          }
        });
        this.listQuery.productId = productIds.length ? productIds : undefined;
        this.listQuery.productVariationId = productVariationIds.length ? productVariationIds : undefined;
      } else {
        if (value.startsWith('product-')) {
          this.listQuery.productId = [+value.replace('product-', '')];
          this.listQuery.productVariationId = undefined;
        } else if (value.startsWith('variation-')) {
          this.listQuery.productId = undefined;
          this.listQuery.productVariationId = [+value.replace('variation-', '')];
        }
      }
    } else {
      // Clear the product filters when value is null or empty
      this.listQuery.productId = undefined;
      this.listQuery.productVariationId = undefined;
    }
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    if (this.listQuery.stateId) {
      this.getCityList(this.listQuery.stateId);
    }
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
    }
  }
  async handleSearch() {
    await this.handleFilter();
    this.hasSearched = true;
    this.getList();
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleSearch();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  toggleDialog(id = 0) {
    this.dialogVisible = true;
    this.dispatchId = id;
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const url = await generateInvoice(id);
    if (url) {
      window.open(url, '_blank');
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: 'Failed to generate invoice',
        type: 'error'
      });
    }
    this.listLoading = false;
  }
  async handleClearCache() {
    try {
      await this.$confirm('Are you sure you want to clear the cache?', 'Confirmation', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      // If user clicks Yes
      await clearItemWiseCache();
      this.$message.success('Cache cleared successfully');
      this.getList();
    } catch (error) {
      // If user clicks No or closes the dialog
      this.$message.info('Cache clear cancelled');
    }
  }
  async handleExcelDownload() {
    this.listQuery = cleanListQuery(this.listQuery);
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    }
    if (!this.listQuery.startDate || !this.listQuery.endDate) {
      this.$message.warning('Please select a date range first to download Excel');
      return;
    }
    try {
      this.downloadLoading = true;
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      queryWithoutPagination.categoryId = this.categoryId || undefined;
      queryWithoutPagination.subCategoryId = this.subCategoryId || undefined;
      const allDataResponse = await getItemWiseReports(getQuery({
        ...queryWithoutPagination,
        limit: 100000
      }));
      const rows = (allDataResponse === null || allDataResponse === void 0 ? void 0 : allDataResponse.data) || [];
      const excelData = rows.map(row => {
        var _row$dealer, _row$dealer2;
        return {
          ID: row.id,
          Dealer: row.dealerName,
          State: row.stateName,
          City: row.cityName,
          Agent: row.agentName,
          'Invoice Number': row.invoiceNumber,
          'Invoice Date': row.createdOn ? moment(row.createdOn).format('DD-MM-YYYY hh:mm a') : '',
          'Approval Date': row.approvalDate ? moment(row.approvalDate).format('DD-MM-YYYY hh:mm a') : '-',
          Item: row.productName,
          Label: row.label,
          'Variation Name': row.productName === row.variationName ? '' : row.variationName,
          Range: row.rangeName,
          'Quantity(PCS)': row.quantity,
          Cartons: row.masterCarton ? Number((row.quantity / row.masterCarton).toFixed(1)) : '',
          'List Rate': row.listRate,
          'Policy Discount(%)': row.policiesPercentDiscount || '',
          'Schemes Discount(%)': row.schemesPercentDiscount || '',
          'MOQ Discount(%)': row.moqsDiscount || '',
          'Net Rate': row.nettRate,
          Amount: row.total,
          'Impact Value': Number(Number(row.impactValue).toFixed(2)),
          'Branch Manager': this.getAdminByRole(row.mappedAdmins || ((_row$dealer = row.dealer) === null || _row$dealer === void 0 ? void 0 : _row$dealer.mappedAdmins), 'Branch Manager'),
          'Zonal Manager': this.getAdminByRole(row.mappedAdmins || ((_row$dealer2 = row.dealer) === null || _row$dealer2 === void 0 ? void 0 : _row$dealer2.mappedAdmins), 'Zonal Manager')
        };
      });
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      XLSX.utils.book_append_sheet(wb, ws, 'Item Wise Report');
      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob = new Blob([wbout], {
        type: 'application/octet-stream'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'item-wise-report.xlsx';
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      var _err$response;
      const err = error;
      const msg = (err === null || err === void 0 ? void 0 : err.message) || (err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.message) || 'Error downloading Excel';
      this.$message.error(msg);
    } finally {
      this.downloadLoading = false;
    }
  }
  getAdminByRole(mappedAdmins, roleName) {
    try {
      if (!mappedAdmins || !Array.isArray(mappedAdmins)) return '';
      const targetRole = roleName.toLowerCase().trim();
      const admin = mappedAdmins.find(a => {
        const rolesList = (a === null || a === void 0 ? void 0 : a.roles) || (a === null || a === void 0 ? void 0 : a.adminsRole) || [];
        return rolesList.some(r => {
          const name = typeof r === 'string' ? r : r === null || r === void 0 ? void 0 : r.name;
          return name && name.toLowerCase().trim() === targetRole;
        });
      });
      return admin ? admin.fullName || admin.name || '' : '';
    } catch {
      return '';
    }
  }
  getVisibleColumns() {
    const table = this.$refs.table;
    const visibleColumns = table.columns.filter(column => !column.hidden);
    return visibleColumns;
  }
  async handleCSVDownload() {
    this.downloadLoading = true;
    try {
      // Call the downloadCSV function to get the Blob object
      const blob = await downloadCSV(this.list);
      // Create URL for the Blob
      const url = window.URL.createObjectURL(blob);
      // Create download link
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'item-wise-report.csv');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading CSV:', error);
      this.$message.error('Error downloading CSV');
    } finally {
      this.downloadLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'ItemWiseReportList',
  components: {
    Pagination,
    Inr,
    Enabled
  }
})], default_1);
export default default_1;